import { colors } from '@material-ui/core';

export default {
  background: {
    dark: '#F4F6F8d9',
    default: colors.common.white,
    paper: colors.common.white
  },
  primary: {
    main: '#1b1918d9'
  },
  secondary: {
    main: colors.indigo[700]
  },
  text: {
    primary: colors.common.black,
    secondary: colors.common.black
  }
};
